var _path, _path2, _ellipse, _ellipse2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlendDarkPod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 38C29.9411 38 38 34.6625 38 30.5455C38 28.8489 36.6314 27.2846 34.3265 26.0318L31.0938 7.14297C30.1015 3.45555 24.7839 1.98236 20 2.00013C15.2541 2.01776 9.8969 3.46069 9.01369 7.14297L5.67347 26.0318C3.36858 27.2846 2 28.8489 2 30.5455C2 34.6625 10.0589 38 20 38Z",
    fill: "#706C69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32837 29.899L9.21726 7.27274C10.1011 3.91414 15.2814 2.5 19.8233 2.5C24.3653 2.5 29.5456 3.91414 30.4294 7.27274L34.3183 29.899C34.3183 33.0031 27.8274 35.3788 19.8233 35.3788C11.8193 35.3788 5.32837 33.0031 5.32837 29.899Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.824,
    cy: 3.91414,
    rx: 3.8889,
    ry: 1.41414,
    stroke: "#2D2926"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.824,
    cy: 3.91414,
    rx: 3.8889,
    ry: 1.41414,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4293 7.44922C30.4293 9.597 25.6808 11.3381 19.8232 11.3381C13.9657 11.3381 9.25 9.49976 9.25 7.44922",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6112 25.8643C35.8294 27.0823 37.1465 28.6031 37.1465 30.2526C37.1465 34.2552 29.3906 37.5 19.8233 37.5C10.2559 37.5 2.5 34.2552 2.5 30.2526C2.5 28.6031 3.81712 27.0823 6.03536 25.8643",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlendDarkPod);
export default __webpack_public_path__ + "static/media/iconBlendDarkPod.8b0ef5606a379ffa473d5bb112a88157.svg";
export { ForwardRef as ReactComponent };